<a
  *ngIf="rowItem.customFields.productType; else noProductType"
  class="button-ghost"
  [routerLink]="[
    '../../extensions/product-type',
    rowItem.customFields.productType.id
  ]"
  ><span> {{ rowItem.customFields.productType.name }}</span></a
>
<ng-template #noProductType>
  <div>*</div>
</ng-template>
